import triggerAfterSaveAssociationHook from '../../../../redux/utils/add/trigger-after-save-association-hook'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import getLocalIdReduxUtil from '../../../../redux/utils/get-local-id'
import isPointerReduxUtil from '../../../../redux/utils/is-pointer'
import { REFERENCES_DOMAIN } from '../../../../references/constants'
import getReferencesSelector from '../../../../references/selectors/get'
import setUtil from '../../../../../utils/set'
import { getObjectUtil, omitObjectUtil } from 'packages/src'

export default function updateInstanceReferences (params) {
  let {
    state,
    instance,
    oldPath,
    existingInstance
  } = params
  const references = getReferencesSelector(oldPath)(state)
  const id = getIdReduxUtil(instance)

  // logSystemUtil('').debug('updateReferenceInstance: oldPath ', oldPath)
  // logSystemUtil('').debug('updateReferenceInstance: oldReferences ',
  // references)
  state = references.reduce((updatedState, reference) => {
    let referenceValue = getObjectUtil(updatedState, reference)
    // logSystemUtil('').debug('updateReferenceInstance: reference ', reference)
    // logSystemUtil('').debug('updateReferenceInstance: referenceValue ',
    // referenceValue)
    if (!referenceValue) {
      return updatedState
    }

    updatedState = triggerAfterSaveAssociationHook({
      updatedState,
      reference,
      instance
    })

    // Update the pointer
    if (Array.isArray(referenceValue)) {
      referenceValue = referenceValue.map(element => {
        if (typeof element === 'number' && element === getLocalIdReduxUtil(
          existingInstance)) {
          return id
        } else if (getIdReduxUtil(element) === getLocalIdReduxUtil(
          existingInstance)) {
          return {
            ...element,
            data: {
              id
            }
          }
        }
        return element
      })
    } else if (isPointerReduxUtil(referenceValue)) {
      referenceValue = {
        ...referenceValue,
        data: {
          id
        }
      }
    } else {
      referenceValue = id
    }
    // logSystemUtil('').debug('updateReferenceInstance: referenceValue after ',
    // referenceValue
    // )
    return setUtil(updatedState, reference, referenceValue)
  }, state)
  const referencesDomain = getObjectUtil(state, REFERENCES_DOMAIN)
  const newReferencesDomain = omitObjectUtil(referencesDomain, [oldPath])
  return setUtil(state, REFERENCES_DOMAIN, newReferencesDomain)
}
